import React from 'react';
import { NavLink } from 'react-router-dom';
import './SideNav.css';

interface Props {
  text: string;
  icon: React.ReactNode;
  to: string;
  id: string;
  testId?: string;
  dataAnalytics?: string;
}

class SideNavItem extends React.Component<Props> {
  static defaultProps = {
    id: '',
  };

  render(): React.ReactNode {
    const { icon, to, text, id, testId, dataAnalytics } = this.props;

    return (
      <NavLink
        id={id}
        data-testid={testId}
        key={to}
        to={to}
        activeStyle={{
          color: 'var(--color-primary)',
          backgroundColor: 'var(--color-white)',
        }}
        className="block decoration-none color-white font-size-4 hover:bg-[#2C72AA]"
        data-analytics={dataAnalytics}
      >
        <div className="row items-center hs3">
          <div className="flex-center sidenav-hide w100 h100">
            <div className="flex-center ws2 hs2">{icon}</div>
          </div>
          <div className="row items-center mx3 sidenav-show">
            <div className="flex-center mr2 ws2 hs2">{icon}</div>
            <div>{text}</div>
          </div>
        </div>
      </NavLink>
    );
  }
}

export default SideNavItem;
